<template>
  <div>
    <a-card v-if="getScreen">
      <span slot="title">Bailout Fund Form</span>
      <a-steps :current="current" status="process">
        <a-step title="Information" />
        <a-step title="Usage" />
        <a-step title="Approval" />
      </a-steps>
      <div class="steps-content flex-1">
        <component
          class="flex-1"
          :is="steps[current].content"
          :ref="stepRef"
          v-bind="stepProps"
        ></component>
      </div>
      <template class="ant-card-actions" slot="actions">
        <div class="steps-action">
          <a-button v-if="current < steps.length - 1" type="primary" @click="next" :disabled="loading.loadingAdd"
            >Next</a-button
          >
          <a-button
            v-if="current == (steps.length - 1)"
            type="default"
            :loading="loading.btnLoading"
            @click="validateConfirm"
            :disabled="dataList.length < 1"
            >{{ isNotDraft === false ? "Save Draft" : "Save" }}</a-button
          >
          <a-button v-if="current > 0" @click="prev" :disabled="loading.loadingAdd || loading.btnLoadingdraft">Previous</a-button>
        </div>
      </template>
    </a-card>
    <a-row :gutter="8" v-else>
      <a-col :span="leftcolumn" class="m-page-wrapper">
        <a-card
          :loading="loading.leftpage"
          class="m-height-full m-display-flex flex-column nowrap"
        >
          <span slot="title">BAILOUT FUND REPORT FORM</span>
          <a-steps :current="current" status="process">
            <a-step title="Information" />
            <a-step title="Usage" />
            <a-step title="Approval" />
          </a-steps>
          <div class="steps-content flex-1">
            <component
              class="flex-1"
              :is="steps[current].content"
              :ref="stepRef"
              v-bind="stepProps"
            ></component>
          </div>
          <template class="ant-card-actions" slot="actions">
            <div class="steps-action">
              <a-button-group>
                <a-button
                v-if="current == 1"
                type="primary"
                @click="handleNew"
                :loading="loading.loadingAdd"
                >Add</a-button
                >
                <a-button
                  v-if="current < steps.length - 1"
                  type="default"
                  @click="next"
                  :disabled="loading.loadingAdd"
                  >Next</a-button
                >
                <a-button
                  v-if="type !== 'revised' && current == steps.length - 1"
                  type="default"
                  :loading="loading.btnLoadingdraft"
                  @click="validasiDraft"
                  :disabled="disableSaveButton"
                  >Save Draft</a-button
                >
                <a-button
                  v-if="current == steps.length - 1"
                  type="primary"
                  :loading="loading.btnLoading"
                  @click="validasi"
                  :disabled="disableSaveButton || loading.btnLoadingdraft"
                  >Save</a-button
                >
              </a-button-group>
              <a-button v-if="current > 0" @click="prev" :disabled="loading.loadingAdd || loading.btnLoadingdraft">Previous</a-button>
            </div>
          </template>
        </a-card>
      </a-col>
      <a-col :span="rightcolumn" class="m-page-wrapper">
        <a-card class="m-height-full m-display-flex flex-column">
          <div slot="title">
            <span>Reporting Details</span>
          </div>
          <template slot="extra">
            <a-button @click="onCollective" class="margin-right-small" icon="edit"
            :loading="loading.loadingCollective"
            :disabled="current!=1 ||loading.loadingAdd"
              >Collective</a-button
            >
            <a-button
              @click="handleExpand()"
              :icon="labelExpand == 'Expand' ? 'arrows-alt' : 'shrink'"
              >{{ labelExpand }}</a-button
            >
          </template>
          <a-table
            :rowKey="(record, index) => {return index;}"
            :columns="columns"
            :dataSource="bailoutReportList"
            :pagination="pagination"
            :loading="loading.loadingTable"
            size="small"
            :scroll="{ x: 750 }"
            bordered
          >
            <template slot="title" slot-scope="">
              <div class="H-tb"><b>BAILOUT FUND</b></div>
            </template>
            <template slot="no" slot-scope="item">
              <span>{{ Number(item)+1 }}</span>
            </template>
            <template slot="date" slot-scope="item">
              <span>{{ moment(item.tanggal_pemakaian).format(getDefaultDateFormat) }}</span>
            </template>
            <template slot="deskripsi" slot-scope="text, item">
              <span><b>{{ item.deskripsi }}</b></span> <br />
              <a-alert
                type="error"
                banner
                v-if="
                  item.kredit != '' &&
                  (item.item_nm == null || item.item_nm == '')
                "
                message="Bailout transaction cannot be empty"
              >
                <!-- <a-icon type="exclamation-circle" /> -->
              </a-alert>
              <template v-else>
                <small>
                  <span>{{ item.kode_anggaran }}</span>
                  <br />
                  <span>{{ item.item_nm }}</span>
                </small>
              </template>
            </template>
            <template slot="commission" slot-scope="index, item">
              <span v-if="item.iscommision=='1'">
                Yes
              </span>
              <span v-else>
                No
              </span>
            </template>
            <template slot="document" slot-scope="index, item">
              <a v-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
                View Document
              </a>
              <span v-else>
                No File Uploaded
              </span>
            </template>
            <template slot="debit" slot-scope="index, item">
              <CurrencyJustified v-if="item.debit" currencyValue="IDR" :valueNumber="item.debit" />
            </template>
            <template slot="kredit" slot-scope="index, item">
              <CurrencyJustified v-if="item.kredit" currencyValue="IDR" :valueNumber="item.kredit" />
            </template>
            <template slot="operation" slot-scope="index, item">
              <a-button-group v-if="item.kredit">
                <a-button type="primary" @click="handleEdit(item)" :loading="loading.loadingEdit && loading.loadkey == item.id" :disabled="current!=1 || loading.loadingAdd">
                  <a-icon type="edit" />
                </a-button>
                <a-button type="danger" @click="handleRemoveDetail(item)" :disabled="current!=1 || loading.loadingAdd" 
                  :loading="loading.loadingDel && item.id==loading.loadkey">
                  <a-icon type="close" />
                </a-button>
              </a-button-group>
            </template>

            <template slot="footer">
              <a-row type="flex">
                <a-col :span="7" :order="1" class="m-text-align left"
                  ><b>Total Bailout Fund</b></a-col
                >
                <a-col :span="7" :order="2" class="m-text-align left m-text-bold">
                  <CurrencyJustified
                    currencyValue="IDR"
                    :valueNumber="TPC ? TPC : 0"
                  />
                </a-col>
                <a-col
                  :span="3"
                  :order="3"
                  class="m-text-align left m-text-bold"
                ></a-col>
              </a-row>
            </template>
          </a-table>
        </a-card>
        <template class="ant-card-actions" slot="actions">
          <div class="steps-action">
            <a-button-group>
              <a-button
              v-if="current == 1"
              type="primary"
              @click="handleNew"
              :loading="loading.loadingAdd"
              >Add</a-button
              >
              <a-button
                v-if="current < steps.length - 1"
                type="default"
                @click="next"
                :disabled="loading.loadingAdd"
                >Next</a-button
              >
              <!-- <a-button
                v-if="current == (steps.length - 1)"
                type="primary"
                :loading="btnLoading"
                @click="validateConfirm"
                :disabled="dataList.length < 1"
                >{{ status === false ? "Save Draft" : "Save" }}</a-button
              >  -->
              <a-button
                v-if="type !== 'revised' && current == steps.length - 1"
                type="default"
                :loading="loading.btnLoading"
                @click="validasiDraft"
                :disabled="disableSaveButton"
                >Save Draft</a-button
              >
              <a-button
                v-if="current == steps.length - 1"
                type="primary"
                :loading="loading.btnLoading"
                @click="validasi"
                :disabled="disableSaveButton"
                >Save</a-button
              >
            </a-button-group>
            <a-button v-if="current > 0" @click="prev" :disabled="loading.loadingAdd || loading.btnLoadingdraft">Previous</a-button>
          </div>
        </template>
      </a-col>
    </a-row>

    <Modal
      v-if="modal.modalEdit"
      :modalEdit="modal.modalEdit"
      :datasource="modal.data"
    />

    <Collective v-if="isCollective" :close="handleCloseCollective">
      <div slot="title">
        <a-icon type="edit" />&nbsp;Edit Collective
      </div>
      <template slot="content">
        <a-form class="margin-bottom" :form="formCollective">
          <a-row :gutter="24">
            <a-col span="12">
              <a-form-item label="PP/SPPD Detail">
                <a-select showSearch placeholder="PP/SPPD Detail" class="select-between" v-decorator="[
                  'id_trans_dtl',
                  { rules: [{ required: true }] },
                ]" option-filter-prop="children" :filter-option="filterOption">
                  <a-select-option v-for="item in list_pppd_collective" :key="item.id_trans_dtl">
                    <div class="select-option">
                      <div v-if="!getScreen">
                        <h4>{{ item.item_nm }}</h4>
                      </div>
                      <h4 v-else>{{ item.item_nm }}</h4>
                      <small>{{
                        formatRupiah(item.saldo)
                          .replace(",00", "")
                      }}</small>
                    </div>
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-row :gutter="24">
                <a-col span="9">
                  <a-form-item label="Activity Type" v-if="$refs.mcostCntr && $refs.mcostCntr.value && $refs.mcostCntr.value.includes('MARDEV')">
                    <a-select placeholder="Please Select" 
                    ref="mrefactivity_type"
                    v-decorator="[
                      'activity_type',
                      { rules: [{ required: true }], initialValue:collectData.informasi.type_activity },
                    ]"
                    disabled
                    @change="changeActivity_type" class="width-full">
                      <a-select-option v-for="item in getMARDEVActivity.type" :key="item">
                        {{item}}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col span="15">
                  <a-form-item label="Activity" v-if="$refs.mcostCntr && $refs.mcostCntr.value && $refs.mcostCntr.value.includes('MARDEV') && $refs.mrefactivity_type && $refs.mrefactivity_type.value!='Project Penetration'">
                    <a-select placeholder="Please Select" 
                    v-decorator="[
                      'activity',
                      { rules: [{ required: true }], initialValue:collectData.informasi.activity },
                    ]" disabled class="width-full">
                      <a-select-option v-for="item in getMARDEVActivity.activity" :key="item">
                        {{item}}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="Pipeline" v-if="$refs.mcostCntr && $refs.mcostCntr.value && $refs.mcostCntr.value.includes('MARDEV') && $refs.mrefactivity_type && $refs.mrefactivity_type.value=='Project Penetration'">
                    <a-select
                      showSearch
                      :not-found-content="null"
                      option-filter-prop="children"
                      v-decorator="[
                        'pipeline_id',
                        {
                          rules: [{ required: true }],
                          initialValue:collectData.informasi.pipeline_id
                        },
                      ]"
                      disabled
                    >
                      <a-select-option v-for="item in pipelineList" :key="item.pipeline_id">
                        [{{ item.pipeline_no}}] {{ item.definitions }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
            <a-col span="12">
              <a-form-item label="Is Commission?">
                <a-radio-group
                  v-decorator="[
                    'iscommision',
                    { rules: [{ required: true }] },
                  ]"
                  @change="handleOptionCommission"
                  :disabled="EnCommission"
                  button-style="solid"
                >
                  <a-radio-button value="1"> Yes </a-radio-button>
                  <a-radio-button value="0"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="With Note?" :hidden="true">
                <a-radio-group
                  v-decorator="[
                    'without_note',
                    { rules: [{ required: false }], initialValue: '0' },
                  ]"
                  button-style="solid"
                >
                  <a-radio-button value="0"> Yes </a-radio-button>
                  <a-radio-button value="1"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <a-table
          :columns="columns"
          :dataSource="getlistCollective"
          :pagination="pagination"
          size="small"
          :scroll="{ x: 750 }"
          :loading="loading.loadingtable"
          bordered
        >
          <template slot="customTitle">
            {{isCollective ? "Check" : "Action"}}&nbsp;
            <a-checkbox v-model="checkAllCollective" @change="onCheckAllChange">
            </a-checkbox>
          </template>
          <template slot="date" slot-scope="item">
              <span>{{ moment(item.tanggal_pemakaian).format(getDefaultDateFormat) }}</span>
            </template>
            <template slot="deskripsi" slot-scope="text, item">
              <span><b>{{ item.deskripsi }}</b></span> <br />
              <a-alert
                type="error"
                banner
                v-if="
                  item.kredit != '' &&
                  (item.item_nm == null || item.item_nm == '')
                "
                message="Bailout transaction cannot be empty"
              >
                <!-- <a-icon type="exclamation-circle" /> -->
              </a-alert>
              <template v-else>
                <small>
                  <span>{{ item.kode_anggaran }}</span>
                  <br />
                  <span>{{ item.item_nm }}</span>
                </small>
              </template>
            </template>
          <template slot="commission" slot-scope="index, item">
              <span v-if="item.iscommision=='1'">
                Yes
              </span>
              <span v-else>
                No
              </span>
            </template>
          <template slot="document" slot-scope="index, item">
            <a v-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
              View Document
            </a>
            <span v-else>
              No File Uploaded
            </span>
          </template>
          <template slot="debit" slot-scope="index, item">
              <CurrencyJustified v-if="item.debit" currencyValue="IDR" :valueNumber="item.debit" />
            </template>
            <template slot="kredit" slot-scope="index, item">
              <CurrencyJustified v-if="item.kredit" currencyValue="IDR" :valueNumber="item.kredit" />
            </template>
          <template slot="operation" slot-scope="index, item">
            <a-checkbox
              :checked="selected.filter(obj => obj.id == item.id).length == 0 ? false : true"
              @change="handleCheck"
              :value="item"
            ></a-checkbox>
          </template>
        </a-table>
      </template>
      <a-button-group slot="action">
        <a-button @click="handleSet" type="primary" :disabled="selected.length == 0"
        :loading="loading.setloading"
        >Set</a-button>
        <a-button
          @click="handleCloseCollective"
          :type="selected.length == 0 ? 'primary' : ''"
        >Done</a-button>
      </a-button-group>
    </Collective>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Informasi from "./steps/Informasi.vue";
import Usage from "./steps/Usage.vue";
import Approval from "./steps/Approval.vue";
import Modal from "./Modal.vue";
import nanoid from "nanoid";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Collective from "../../components/collective/Collective.vue";
import CollectiveBailoutFundReport from "@/mixins/collective/collectiveBailoutFundReport";

export default {
  name: "BailoutFundReport",
  mixins: [CollectiveBailoutFundReport,CurrencyFormat,GlobalMethod],
  props: ["id", "type"],
  components: {
    Informasi,
    Usage,
    Approval,
    Modal,
    Collective
  },
  data() {
    return {
      status: false,
      loading:{
        btnLoadingdraft: false,
        loadingCollective: false,
        btnLoading: false,
        leftpage: false,
        loadingAdd: false,
        loadingDel: false,
        loadingTable: false,
        loadingEdit: false,
        setloading: false,
        loadkey: ""
      },
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "Usage",
          content: "Usage",
        },
        {
          title: "Approval",
          content: "Approval",
        },
      ],
      collectData:{
        information: [],
        usage: [],
        approval: [],
        catatan: ""
      },
      isNotDraft: false,
      dataList: [],
      leftcolumn: 12,
      rightcolumn: 12,
      labelExpand: "Expand",
      disableSaveButton: false,
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      picForColumn: "",
      id_lkb_draft: nanoid(),
      bailoutReportList: [],
      bailoutTransmodeEdit:[],
      modal:{
        modalEdit: false,
        data: {
          id: null,
          list_pppd: [],
          selected_pppd: []
        }
      },
      isCollective: false,
      EnCommission: true,
      Viwithout_note: true,
      checkAllCollective: true,
      list_pppd_collective: [],
      mode: null
    }
  },
  mounted(){
    this.mode = ("draft"==this.type || this.type==null? 'Create' : 'Edit')
    Event.$on("stepsBailoutReportForm",this.collectStepChild);
    Event.$on("fetchBailloutDtlList",this.fetchBailoutFundList);
    Event.$on("handleLoading",this.setloadingAdd);
    Event.$on("modalEditCancel", this.handleEditCancel);
    Event.$on("stepsBailoutReportFormCatatan", this.saveApprovalCatatan);
    Event.$on("confirmDraftReturn", this.validate);
    Event.$on("confirmMessageReturn", this.validate);
    Event.$on("reloadCollectivePPSPPD", this.reloadCollectivePPSPPD);

    if(this.id || this.type=='draft'){
      this.fetchBailoutFundList()
    }
  },
  beforeDestroy() {
    Event.$off("stepsBailoutReportForm",this.collectStepChild);
    Event.$off("fetchBailloutDtlList",this.fetchBailoutFundList);
    Event.$off("handleLoading",this.setloadingAdd);
    Event.$off("modalEditCancel", this.handleEditCancel);
    Event.$off("stepsBailoutReportFormCatatan", this.saveApprovalCatatan);
    Event.$off("confirmDraftReturn", this.validate);
    Event.$off("confirmMessageReturn", this.validate);
    Event.$off("reloadCollectivePPSPPD", this.reloadCollectivePPSPPD);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate"
    ]),
    stepProps: function () {
      if (this.steps[this.current].content === "Informasi") {
        return {
          type: this.type,
          id: this.id,
          mode: this.mode,
          bailoutTransmodeEdit: this.bailoutTransmodeEdit,
          collectData: this.collectData
        };
      } else if (this.steps[this.current].content === "Usage") {
        return {
          type: this.type,
          id: this.id,
          mode: this.mode,
          collectData: this.collectData,
          informasi: this.collectData.information,
          id_lkb_draft: this.id_lkb_draft
        }
      } else {
        return {
          type: this.type,
          id: this.id,
          mode: this.mode,
          collectData: this.collectData,
          lisAppr: this.collectData.approval,
          id_lkb_draft: this.id_lkb_draft
        }
      }
    },
    stepRef: function () {
      if (this.steps[this.current].content === "Informasi") {
        return "refInformasi";
      } else if (this.steps[this.current].content === "Usage") {
        return "refUsage";
      } else if (this.steps[this.current].content === "Approval"){
        return "refApproval";
      }
      return true;
    },
    columns(){
      return [
        {
          title: "#",
          key: "number",
          dataIndex: "sequence",
          width: 50,
          scopedSlots: { customRender: "no" },
          align: "right",
        },
        {
          title: "Date",
          key: "date",
          align: "center",
          scopedSlots: { customRender: "date" },
          width: 100,
        },
        {
          title: "Description",
          key: "deskripsi",
          scopedSlots: { customRender: "deskripsi" },
          width: 200,
        },
        {
          title: "Document",
          key: "document",
          scopedSlots: { customRender: "document" },
          width: 150,
          align: "center"
        },
        {
          title: "Commission",
          key: "commission",
          scopedSlots: { customRender: "commission" },
          width: 125,
          align: "center"
        },
        {
          title: "Debit",
          key: "debit",
          align: "right",
          width: 170,
          scopedSlots: { customRender: "debit" },
          sorter: (a, b) => a.debit.length - b.debit.length,
        },
        {
          title: "Credit",
          key: "kredit",
          align: "right",
          width: 170,
          scopedSlots: { customRender: "kredit" },
          sorter: (a, b) => a.kredit.length - b.kredit.length,
        },
        {
          slots: { title: 'customTitle' },
          key: "operation",
          align: "center",
          scopedSlots: { customRender: "operation" },
          width: 120,
          fixed: "right"
        },
        
      ]
    },
    getlistCollective(){
      let data = _.filter(this.bailoutReportList, item=>Number(item.debit)==0)
      let dataDebit = _.filter(this.bailoutReportList, item=>Number(item.debit)>0)
      let debit = dataDebit[0].debit;
      if (data) {
        data.forEach((value, index) => {
          if (value.debit !== "") {
            debit += value.debit;
            data[index]["debit_value"] = this.formatCurrency(
              this.mata_uang,
              value.debit
            );
            data[index]["sisa"] = this.formatCurrency(this.mata_uang, debit);
          } else {
            data[index]["debit_value"] = "-";
          }

          data[index]["no"] = index + 1;
          data[index]["key"] = index;

          if (value.kredit !== "") {
            data[index]["kredit_value"] = this.formatCurrency(
              this.mata_uang,
              value.kredit
            );
            debit -= value.kredit;
            data[index]["sisa"] = this.formatCurrency(this.mata_uang, debit);

            data[index]["sisa_value"] = debit;
          } else {
            data[index]["kredit_value"] = "-";
          }
          data[index]["tanggal"] = moment(
            value.tanggal_pemakaian,
            this.getStandartFormatDate
          ).format(this.getDefaultDateFormat);
        });
      }
      return data;
    },
    TPC(){
      return _.sumBy(this.bailoutReportList, function (val) {
        return Number(val.kredit)
      });
    },
  },
  methods: {
    moment,
    ...mapActions([]),
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      }else if(this.steps[this.current].content === "Usage"){
        let exceedDate = _.filter(this.bailoutReportList, item => moment(item.tanggal_pemakaian).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD'))
        if(exceedDate.length>0){
          this.displayMessageValue("error-other", "Usage date can't exceed today!");
          return;
        }

        this.$refs.refUsage.handleRef();
      }
    },
    prev(){
      this.expandcolumn('collapse')
      this.current--;
    },
    validateConfirm(){
    },
    validasiDraft(){
      this.confirmMessage("confirm-draft");
    },
    validate() {
      this.$refs.refApproval.handleRef();
      this.loading.btnLoading = true;
      // console.log(this.status);
      if (this.status) {
        let postData;
        let method;
        let contentType;
        let link;
        if (this.type === "revised") {
          method = "put";
          contentType = "application/json";
          link = "/pu/lap/bailout/manifest/" + this.id;
          postData = {
            tlc: this.getAuth.username,
            id_lkb: this.id,
            // approval_pic: this.collectData.informasi.pic,
            tanggal_pelaporan:
              this.collectData.information.tanggal_pelaporan.format("YYYY-MM-DD"),
            public_manifest_url: link,
            catatan: this.collectData.catatan ?
              this.collectData.catatan : '',
          };
        } else {
          method = "post";
          contentType = "multipart/form-data";
          postData = new FormData();
          link = "/pu/lap/bailout/manifest/" + this.id;

          if (this.mode === "Edit") {
            postData.append("id_lkb", this.id);
          } else {
            postData.append("id_lkb", this.id);
          }
          postData.append("catatan", this.collectData.catatan);
        }
        axios({
          method: method,
          url: this.$serviceUrl + "bailout_report",
          data: postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": contentType,
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-save");
            this.loading.btnLoading = false;
            this.$router.push({ name: "bailoutfundreportManifest" });
            // if(this.$route.path.includes("/keuangan/")){
            //   this.$router.push({ name: "bailoutfundreportManifest" });
            // }else{
            //   this.$router.push({ name: "klaimCC" });
            // }
          })
          .catch((err) => {
            let response = Object.assign({}, err.response);
            if (
              response.data.message.includes("Tidak Memiliki Detil Pemakaian")
            ) {
              this.displayMessageValue(
                "error-other",
                response.data.message
              );
            } else {
              let responses = Object.assign({}, err.response);
              if (responses.data) {
                this.displayMessageValue("error-other", responses.data.message);
              } else {
                this.displayMessageValue("error", responses);
              }
            }
            this.loading.btnLoading = false;
          });
      } else {
        this.savecatatan();
      }
    },
    savecatatan(){
      this.loading.btnLoadingdraft = true
      axios({
          method: "post",
          url: this.$serviceUrl + "bailout_report/draft",
          data: {
            id_lk : this.id ? this.id : this.id_klaim,
            catatan: this.collectData.catatan
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then(() => {
            this.loading.btnLoadingdraft = false
            this.displayMessage("success-edit");
            this.$router.push({ name: "bailoutfundreport" });
          })
          .catch((response) => {
            let responses = Object.assign({}, response.data);
            this.displayMessageValue("error-other",responses);
          });
    },
    handleNew(){
      this.$refs.refUsage.handleNew()
    },
    async onCollective(){
      this.selected = []
      this.loading.loadingCollective = true
      await this.reloadCollectivePPSPPD()

      this.EnCommission = false;
      this.Viwithout_note = true;
      this.isCollective = true;
      this.formCollective.resetFields();
      // this.formCollective.setFieldsValue({
      //         id_trans_dtl: null,
      //         iscommision: "0",
      //         without_note: "0",
      //     });
      this.$nextTick(function () {
        this.formCollective.resetFields();
      //     this.formCollective.setFieldsValue({
      //         id_trans_dtl: null,
      //         iscommision: "0",
      //         without_note: "0",
      //     });
      })

      if(this.checkAllCollective){
          this.checkAllCollective = false
          let temcheck = {
              target:{checked: false}
          }
          this.onCheckAllChange(temcheck)
      }
    },
    async reloadCollectivePPSPPD(){
      await axios({
        method: "get",
        url: this.$serviceUrl + "bailout_report/bailout_detil",
        params: {
          id_bailout: this.collectData.information.id_bailout,
          id_lkb_draft: this.id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then((res) => {
        this.list_pppd_collective = res.data.list_nama_item;
        this.loading.loadingCollective = false
      })
      .catch(() => {
      });
    },
    handleExpand(){
      if (this.leftcolumn == 12 && this.rightcolumn == 12) {
        this.leftcolumn = 0;
        this.rightcolumn = 24;
        this.labelExpand = "Collapse";
        this.pagination.pageSize = 10;
      } else {
        this.leftcolumn = 12;
        this.rightcolumn = 12;
        this.labelExpand = "Expand";
        this.pagination.pageSize = 5;
      }
    },
    expandcolumn(val){
      if(val=="expand"){
          this.leftcolumn = 24;
          this.rightcolumn = 0;
      }else{
          this.leftcolumn = 12;
          this.rightcolumn = 12;
      }
    },
    collectStepChild(value){
      if (this.steps[this.current].content === "Informasi") {
        this.collectData.information = value;
        this.current++;
      }else if (this.steps[this.current].content === "Usage") {
        let validateData = _.filter(this.bailoutReportList, item=>item.kode_anggaran=="" && item.debit=="")
        if(this.bailoutReportList.length<=1){
          this.displayMessageValue("error-other", "Bailout Fund Can't be empty!");
        } else if(validateData.length>0){
          this.displayMessageValue("error-other", "there is still an empty PP/PD Detail, please complete it!");
        }else{
          this.collectData.usage = this.bailoutReportList;
          this.expandcolumn('expand')
          this.current++;
        }
      }else{
        this.collectData.approval = value;
      }
    },
    fetchBailoutFundList() {
      this.loading.loadingTable = true
      axios({
        method: "get",
        url: this.$serviceUrl + (this.id && this.type!='draft' ? "bailout_report/revisi_detil_pemakaian" : "bailout_report/detil_pemakaian"),
        params: {
          id_lk: this.id ? this.id : this.id_lkb_draft
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((res) => {
          this.bailoutReportList = res.data.detail_pemakaian;
          if(this.id && this.bailoutTransmodeEdit.length==0){
            this.bailoutTransmodeEdit = res.data.no_trans

            this.collectData.information = {
              id_bailout: res.data.id_bailout, 
              tanggal_pelaporan: res.data.tgl_buat
            }
            this.collectData.catatan = res.data.catatan
            this.collectData.usage = this.bailoutReportList;
          }
          this.loading.loadingTable = false
        })
        .catch(() => {
        });
    },
    handleRemoveDetail(item){
      if(this.bailoutReportList.length==2){
        this.displayMessageValue("error-other", "Can't be delete because minimum detail is one!");
        return;
      }
      this.loading.loadkey = item.id
      this.loading.loadingDel = true
      axios({
        method: "delete",
        url: this.$serviceUrl + "bailout_report/detil_pemakaian",
        data: {
          id: item.id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then(async (res) => {
        this.displayMessage("success-del");
        Event.$emit("fetchUmList", true);
        await this.fetchBailoutFundList()
        this.loading.loadingDel = false
      })
    },
    setloadingAdd(val){
      this.loading.loadingAdd = val
    },
    async handleEdit(item) {
      this.loading.loadingEdit = true
      this.loading.loadkey = item.id
      let listppsppd = []
      await this.asyncAxiosGet((this.type=="revised" ? "bailout_report/revisi_detil_pemakaian_update" : "bailout_report/detil_pemakaian_update"), this.getAuth, {
          id: item.id,
        })
        .then((response) => {
          listppsppd = response.list_dtl
          this.loading.loadingEdit = false
        })

      this.modal.data = {
        selected_pppd: item.id_trans_dtl,
        list_pppd: listppsppd,
        tanggal_pemakaian: item.tanggal_pemakaian,
        deskripsi: item.deskripsi,
        kredit: item.kredit,
        id: item.id,
        type: this.type,
        iscommision: item.iscommision ? item.iscommision : "0",
        without_note: item.without_note ? item.without_note : "1",
      };

      if (!item.iscommision){
        this.modal.data.EnCommission=true;
        this.modal.data.Viwithout_note=true;
      }else if(item.iscommision=="1" && item.is_komisi_ori){
        this.modal.data.EnCommission=true;
        this.modal.data.Viwithout_note=false;
      }else if(item.iscommision=="1" && !item.is_komisi_ori){
        this.modal.data.EnCommission=false;
        this.modal.data.Viwithout_note=false;
      }else{
        this.modal.data.iscommision=="0";
        this.modal.data.EnCommission=false;
        this.modal.data.Viwithout_note=true;
      }
      if (item.lampiran) {
        this.loading.loadingEdit = true;
        await this.asyncAxiosGet("main/base_64", this.getAuth, {
          path: item.lampiran_path,
        })
        .then((response) => {
          let typefile = this.fileTypeFromUrl(item.lampiran);
          let file = this.dataURLtoFile(
            typefile + response.file_document_tax,
            item.lampiran
          );
          file.uid = "vc-upload-1-1";
          file.status = "done";
          file.url = this.$serviceUrl + item.lampiran_path;
          this.modal.data.doctransfiles = [];
          this.modal.data.doctransfiles.push(file);

          this.modal.modalEdit = true;
          this.loading.loadingEdit = false;
          this.modal.type = this.type;
        })
          .catch((err) => {
          this.loading.loadingEdit = false;
          console.log(err);
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
      } else {
        this.modal.modalEdit = true;
        this.modal.type = this.type;
      }
    },
    handleEditCancel(){
      this.modal.modalEdit = false
    },
    viewlampiranDoc(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    handleOptionCommission(val){
      if(val.target.value=="1"){
        this.Viwithout_note = false;
      }else{
        this.Viwithout_note = true;
      }
      this.$nextTick(function () {
          this.formCollective.setFieldsValue({
              without_note: "0",
          });
        });
    },
    onCheckAllChange(val){
      this.getlistCollective.forEach((element) => {
        if(element.edit_hapus!='0'){
          let index = _.findIndex(
            this.selected,
            (e) => {
              return e.id == element.id;
            }
          );

          if(val.target.checked){
            if(index < 0){
              this.selected.push(element)
            }
          }else{
            if(index >= 0){
              this.selected = _.filter(this.selected, (e) => e.id!=element.id)
            }
          }
        }
      })
    },
    saveApprovalCatatan(val){
      this.collectData.catatan = val.note
    },
    validasi() {
      if (!this.getScreen) {
        this.status = true;
      } else {
        this.status = false;
      }
      if (this.mode === "Edit") {
        this.confirmMessage("confirm-edit");
      } else {
        this.confirmMessage("confirm-save");
      }
    },
  }
}
</script>